// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { arbitrumNova as _arbitrumNova } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the arbitrumNova chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 42170
 * Chain Name: Arbitrum Nova
 * Default Block Explorer: https://nova.arbiscan.io
 * Default RPC URL: https://nova.arbitrum.io/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { arbitrumNova } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: arbitrumNova,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const arbitrumNova = createCommon({
	..._arbitrumNova,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
